import * as React from 'react';

import { useLockFn, useRequest } from 'ahooks';
import { Button, Col, Flex, Form, notification, Row } from 'antd';

import {
  CheckOutlinedIcon,
  PrimitiveForm,
  PrimitiveSortableSelect,
} from 'components';
import { getBrands, updateMainPageBrands } from 'services';
import type { BrandSummary, SelectOption } from 'types';
import { generateSelectOptions, normalizeToString } from 'utils';

type FieldType = {
  brands: SelectOption[];
};

type PageBuilderMainBrandsProps = {
  brands: BrandSummary[];
};

const PageBuilderMainBrands = ({ brands }: PageBuilderMainBrandsProps) => {
  const [form] = Form.useForm<FieldType>();
  const { data: brandsData, loading: brandsLoading } = useRequest(getBrands, {
    cacheKey: 'brands',
  });

  const { brands: allBrands = [] } = brandsData ?? {};
  const brandsSelectOptions = generateSelectOptions(
    allBrands,
    'id',
    'title',
    'id',
  );
  const defaultBrands = brands.map(({ id, title }) => ({
    value: id,
    label: title,
  }));

  const onFinish = useLockFn(async ({ brands = [] }: FieldType) => {
    const brandsIds = brands.map(({ value }) => normalizeToString(value));

    return updateMainPageBrands({ brandsIds })
      .then(() => {
        notification.success({
          message: 'برندها با موفقیت ذخیره شد.',
        });
      })
      .catch(message => {
        notification.error({ message });
      });
  });

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Row>
        <Col span={24}>
          <Form.Item<FieldType>
            label='برندها'
            name='brands'
            extra='برندها را انتخاب کنید و با کشیدن، ترتیب نمایش آن‌ها را تغییر دهید.'
            initialValue={defaultBrands}
          >
            <PrimitiveSortableSelect
              placeholder='برندها را انتخاب کنید'
              loading={brandsLoading}
              options={brandsSelectOptions}
            />
          </Form.Item>
        </Col>
      </Row>
      <Flex justify='end' className='pb-2'>
        <Form.Item className='mb-0'>
          <Button type='primary' htmlType='submit' icon={<CheckOutlinedIcon />}>
            ذخیره تغییرات
          </Button>
        </Form.Item>
      </Flex>
    </PrimitiveForm>
  );
};

export { PageBuilderMainBrands };
